<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <div class="header">
      <div class="text">
        {{ 'CREATE_CREDIT_NOTE.title' | translate}} | {{bill_id}}
      </div>
      <i class="material-icons" (click)="closeModal();">clear</i>
    </div>
    <div class="section">
      <div class="narration">
        <div class="heading">
          {{ 'CREATE_CREDIT_NOTE.narration' | translate}}
        </div>
        <div class="reasonBox">
          <textarea [placeholder]="'CREATE_CREDIT_NOTE.narration_p' | translate" autofocus="false" [(ngModel)]="narration"> </textarea>
        </div>
      </div>
        <div class="credit-table">
            <table  mat-table [dataSource]="credit_notes" style="width:100%;height:auto" class="invoice-table" #table>
                <ng-container matColumnDef="slno">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'CREATE_CREDIT_NOTE.slno' | translate}} </th>
                  <td mat-cell *matCellDef="let element; let i = index" style="width: 40px;">
                    {{ i + 1 }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="reference">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> Reference ID </th>
                  <td mat-cell *matCellDef="let element" style="width: 80px;">
                    <input type="text" style="width:80px"  [(ngModel)]="element.reference">
                  </td>
              </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'CREATE_CREDIT_NOTE.description' | translate}} </th>
                    <td mat-cell *matCellDef="let element" style="width: 80px;">
                      <input type="text" style="width:200px"  [(ngModel)]="element.description">
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'CREATE_CREDIT_NOTE.amount' | translate}} ({{currencySymbol}})</th>
                  <td mat-cell *matCellDef="let element; let i=index" style="width: 80px;">
                    <input type="number" oninput="validity.valid||(value='');" min="0.01" step="0.001" style="width:80px" [(ngModel)]="element.amount">
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'CREATE_CREDIT_NOTE.action' | translate}} </th>
                  <td mat-cell *matCellDef="let element;let i = index;" style="width: 80px;">
                    <i class="material-icons delete action" (click)="i !=0  ? deleteCreditNote(i) : '';"> cancel </i>
                    <i class="material-icons add action" *ngIf="i == credit_notes.length-1" (click)="addNewCreditNote()"> add_circle </i>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns;sticky: true" style="font-weight: bold !important;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns; let index = i"></tr>
              </table>
        </div>
        <div class="other-details">
          <div class="detail">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.total' | translate}} :
            </span>
            <span class="value">
              {{calculateTotal()}}
            </span>
          </div>           
          <div class="detail" style="font-weight: normal;" *ngIf="transit_type == 'INTRA' && this.country == 'IN'">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.sgst' | translate}} ({{gst / 2}}%) :
            </span>
            <span class="value">
              {{calculateSGST()}}
            </span>
          </div> 
          <div class="detail" style="font-weight: normal;" *ngIf="transit_type == 'INTRA' && this.country == 'IN'">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.cgst' | translate}} ({{gst / 2}}%) :
            </span>
            <span class="value">
              {{calculateSGST()}}
            </span>
          </div> 
          <div class="detail" style="font-weight: normal;" *ngIf="transit_type == 'INTER' && this.country == 'IN'">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.igst' | translate}} ({{gst}}%) :
            </span>
            <span class="value">
              {{calculateIGST()}}
            </span>
          </div> 
          <div class="detail" style="font-weight: normal;" *ngIf="reverse_charge == 'Yes' && this.country == 'IN'">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.reversible' | translate}} ({{gst}}%) :
            </span>
            <span class="value">
              {{calculateIGST()}}
            </span>
          </div> 
          <div class="detail" style="font-weight: normal;" *ngIf="this.country == 'SA' || this.country == 'BR'">
            <span class="label">
              {{'CREATE_CREDIT_NOTE.gst' | translate}} ({{gst}}%) :
            </span>
            <span class="value">
              {{calculateVAT()}}
            </span>
          </div> 
        </div>
        <div class="other-details">
          <div class="detail">
            <div class="label">
              {{'CREATE_CREDIT_NOTE.total_credit_note' | translate}} : 
            </div>
            <div class="value">
              {{currencySymbol}} {{calculateTotalCreditNote()}}
            </div>
          </div>
        </div>
      <div class="submitButtonYes" (click)="createCreditNote();" >
        <div class="button" style="background-color: #73235c;">
          {{'CREATE_CREDIT_NOTE.submit' | translate}}
        </div>
      </div>
    </div>
  </div>